import React, { useState } from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
  Grid,
  Popover
} from '@material-ui/core';
import { Draggable } from 'react-beautiful-dnd';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { TCategoryDetailItem } from '../../types/partnerCategory';
import { ButtonList } from './ButtonList';
import './style.css';

type Tprops = {
  item: TCategoryDetailItem;
  index: number;
  setSelectItem: any;
  detailItemFlg: boolean;
  setDetailItemFlg: React.Dispatch<React.SetStateAction<boolean>>;
  setCreateModal: React.Dispatch<React.SetStateAction<boolean>>;
  setUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleCloseSuccess: () => void;
};

export const DetailItem: React.FC<Tprops> = (props: Tprops) => {
  const {
    item,
    index,
    setSelectItem,
    detailItemFlg,
    setDetailItemFlg,
    setCreateModal,
    setUpdateModal,
    setDeleteModal,
    handleCloseSuccess
  } = props;

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      buttonArea: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
      },
      vertButton: {
        cursor: 'pointer',
        marginLeft: 12,
        borderRadius: '50%'
      }
    })
  );

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <Draggable index={index} draggableId={`small-${item.id}`} key={item.id}>
        {provided => (
          <Grid
            item
            xs={12}
            // className={classes.smallItem}
            className='detailItem'
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
          >
            <Grid container>
              {/* 項目 */}
              <Grid item xs={8}>
                {item.name}
              </Grid>
              <Grid item xs={3}>
                {item.registered > 0 && (
                  <div
                    style={{ paddingLeft: 20, fontSize: 14, color: '#52555f' }}
                  >
                    登録社数:{item.registered}
                  </div>
                )}
              </Grid>
              <Grid item xs={1} className={classes.buttonArea}>
                {/* ケバブボタン */}
                <div className='detailMenuButton'>
                  <MoreVertIcon
                    className={classes.vertButton}
                    aria-describedby={id}
                    onClick={(event: any) => {
                      handleCloseSuccess();
                      handleClick(event);
                      setSelectItem(item);
                      setDetailItemFlg(true);
                    }}
                  />
                  {/* ボタンリスト */}
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  >
                    <ButtonList
                      item={item}
                      detailItemFlg={detailItemFlg}
                      setDetailItemFlg={setDetailItemFlg}
                      setCreateModal={setCreateModal}
                      setUpdateModal={setUpdateModal}
                      setDeleteModal={setDeleteModal}
                      handleClose={handleClose}
                    />
                  </Popover>
                </div>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Draggable>
    </>
  );
};
